import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={logoIconStyle}>AR</div>
        <div style={logoTextStyle}>Autonomy Resources</div>
      </Link>
    </div>
  );
}

const logoIconStyle = {
  width: '36px',
  height: '36px',
  borderRadius: '8px',
  background: 'linear-gradient(135deg, #0EA5E9, #14B8A6)',
  color: '#ffffff',
  fontSize: '13px',
  fontWeight: '800',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  letterSpacing: '-0.02em',
  flexShrink: 0
};

const logoTextStyle = {
  fontSize: '16px',
  fontWeight: '700',
  color: '#0F172A',
  letterSpacing: '-0.01em',
  lineHeight: 1
};

export default Logo;
